import { AxiosRequestConfig } from 'axios';
import surveillanceServices from '../services/surveillanceServices';
import { RequestSurveillancePostType, SurveillanceResponse } from '../@types/surveilanceTypes';

export async function fetchPaginatedSurveillances(config: AxiosRequestConfig) {
    const response = await surveillanceServices.getSurveillances(config);
    return response;
}

export async function fetchSurveillancesTileKey(config: AxiosRequestConfig) {
    config.params = {
      ...config.params,
      tileKey: true
    };
    const response = await surveillanceServices.getSurveillancesTileKey(config);
    return response;
};

export async function fetchSurveillanceById(id: string) {
    const response = await surveillanceServices.getSurveillanceById(id);
    return response;
}

export async function deleteSurveillanceById(id: string) {
    const response = await surveillanceServices.deleteSurveillanceById(id);
    return response;
}

export async function createSurveillance(surveillanceData: SurveillanceResponse) {
    const response = await surveillanceServices.createSurveillance(surveillanceData);
    return response;
}

export async function updateSurveillance(id: string, updatedSurveillanceData: RequestSurveillancePostType) {
    const response = await surveillanceServices.updateSurveillance(id, updatedSurveillanceData);
    return response;
}

export async function fetchSurvMapInformation(config: AxiosRequestConfig) {
    const response = await surveillanceServices.getSurvMapInformation(config);
    return response;
}

// URLs para os gráficos
export const survGraphics = {
    fiscalizacaoGeral: 'surv_records/fiscalizacao_geral',
    fiscalizacaoTipo: 'surv_records/fiscalizacao_tipo',
    fiscalizacaoTestes: 'surv_records/fiscalizacao_testes',
    fiscalizacaoRecusas: 'surv_records/fiscalizacao_recusas',
    fiscalizacaoPositivas: 'surv_records/fiscalizacao_positivos',
    fiscalizacaoAbordagens: 'surv_records/fiscalizacao_abordagens',
    fiscalizacaoRemocoes: 'surv_records/fiscalizacao_remocoes',
};